export default __webpack_public_path__ + "locales/uk-UA/DeleteThirdPartyDialog.json?hash=4496a2243c6a450aa92f6bfea08a5b06";